module.exports = __webpack_public_path__ + "img/cc-kuda.e687fa05.png";